import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import sectionService from "../../services/section-service";
import userService from "../../services/user-service";
import dashboardService from "../../services/dashboard-service";
import { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider, Spin } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import BarchartDay from "../DashBoard/BarchartDay";
import moment, { duration } from "moment/moment";
import { ToastContainer, toast } from 'react-toastify';
import Select from "react-select";


// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const ComparativeCycles = () => {


   const referencePalmList = [
    { id: "firstPalm", name: "Primera palma del lote" },
    { id: "lastPalm", name: "Ultima palma del lote" },
    { id: "lastVisited", name: "Ultima palma visitada" }
  ];

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();


  const [limit, setLimit] = useState(6);

  const [startDateC1, setStartDateC1] = useState("");
  const [endDateC1, setEndDateC1] = useState("");
  const [startDateC2, setStartDateC2] = useState("");
  const [endDateC2, setEndDateC2] = useState("");
  const [startDateC3, setStartDateC3] = useState("");
  const [endDateC3, setEndDateC3] = useState("");

  const [startDateC4, setStartDateC4] = useState("");
  const [endDateC4, setEndDateC4] = useState("");
  const [startDateC5, setStartDateC5] = useState("");
  const [endDateC5, setEndDateC5] = useState("");


  const [daysC1, setDaysC1] = useState("");
  const [daysC2, setDaysC2] = useState("");
  const [daysC3, setDaysC3] = useState("");
  const [daysC4, setDaysC4] = useState("");
  const [daysC5, setDaysC5] = useState("");

  const [firstAppC1, setFirstAppC1] = useState("");
  const [firstAppC2, setFirstAppC2] = useState("");
  const [firstAppC3, setFirstAppC3] = useState("");
  const [firstAppC4, setFirstAppC4] = useState("");
  const [firstAppC5, setFirstAppC5] = useState("");

  const [secondAppC1, setSecondAppC1] = useState("");
  const [secondAppC2, setSecondAppC2] = useState("");
  const [secondAppC3, setSecondAppC3] = useState("");
  const [secondAppC4, setSecondAppC4] = useState("");
  const [secondAppC5, setSecondAppC5] = useState("");

  const [thirdAppC1, setThirdAppC1] = useState("");
  const [thirdAppC2, setThirdAppC2] = useState("");
  const [thirdAppC3, setThirdAppC3] = useState("");
  const [thirdAppC4, setThirdAppC4] = useState("");
  const [thirdAppC5, setThirdAppC5] = useState("");




  const [listCyclesPalm, setListCyclesPalm] = useState([])

  const [key, setKey] = useState(Date.now());
  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)
  const [loading, setLoading] = useState(false);

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [sectionId, setSectionId] = useState("0");
  const [farmId, setFarmId] = useState("0");
  const [palmName, setPalmName] = useState("0");
  const [lineName, setLineName] = useState("0");


  ////CONSTANTES DE COORRELACION////////////////////////
  const [title, setTitle] = useState("Ciclos de polinización por sección")
  const [subTitle, setSubTitle] = useState("Ciclos de polinización por sección agrupado por mes")




  const [dataCycles, setDataCycles] = useState([])
  const [listFirstHectareLot, setListFirstHectareLot] = useState([])


  registerLocale("es", es);

  const start_date = moment().subtract(3, 'month').startOf('day').toDate();
  const end_date =moment().endOf("day").toDate();
  //const end_date = moment().endOf("day").toDate();


  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);


  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);


  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////






  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }


    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };




  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };






  /// OBTENER DATOS DE CICLOS POR PALMA
  // OBTENER DATOS DE CICLOS POR PALMA
  const getDataCyclesPalm = async (start_date, end_date) => {


    setPalmName("0")
    setLineName("0")

    setStartDateC1("")
    setEndDateC1("")
    setDaysC1("")

    setStartDateC2("")
    setEndDateC2("")
    setDaysC2("")

    setStartDateC3("")
    setEndDateC3("")
    setDaysC3("")

    setStartDateC4("")
    setEndDateC4("")
    setDaysC4("")

    setStartDateC5("")
    setEndDateC5("")
    setDaysC5("")


    setLoading(true);
    let start = moment(start_date).startOf("day").format('YYYY-MM-DD');
    let end = moment(end_date).endOf("day").format('YYYY-MM-DD');
    const userId = getValues("userId")
    const reference = getValues("palm")

    const params = { startDate: start, endDate: end, farmId, lotId, sectionId, lots: selectedLotes, userId, limit, reference };
    const response = await dashboardService.cyclesByPalm(params);
    const rows = response.data
    setPalmName(response.palmName)
    setLineName(response.lineName)

    // Variables temporales para almacenar los valores
    let tempStartDateC1 = "", tempEndDateC1 = "";
    let tempStartDateC2 = "", tempEndDateC2 = "";
    let tempStartDateC3 = "", tempEndDateC3 = "";
    let tempStartDateC4 = "", tempEndDateC4 = "";
    let tempStartDateC5 = "", tempEndDateC5 = "";

    let listado = []
    setListCyclesPalm(listado)

    if (rows) {
      setListCyclesPalm(rows)

      let contador = 0;
      rows.map((item) => {
        contador++

        if (contador == 1) {
          setStartDateC1(item.startDate)
          setEndDateC1(item.endDate)
          setDaysC1(item.duration)
          tempStartDateC1 = item.startDate;
          tempEndDateC1 = item.endDate;
        }
        else if (contador == 2) {
          setStartDateC2(item.startDate)
          setEndDateC2(item.endDate)
          setDaysC2(item.duration)
          tempStartDateC2 = item.startDate;
          tempEndDateC2 = item.endDate;
        }
        else if (contador == 3) {
          setStartDateC3(item.startDate)
          setEndDateC3(item.endDate)
          setDaysC3(item.duration)
          tempStartDateC3 = item.startDate;
          tempEndDateC3 = item.endDate;
        }
        else if (contador == 4) {
          setStartDateC4(item.startDate)
          setEndDateC4(item.endDate)
          setDaysC4(item.duration)
          tempStartDateC4 = item.startDate;
          tempEndDateC4 = item.endDate;
        }
        else if (contador == 5) {
          setStartDateC5(item.startDate)
          setEndDateC5(item.endDate)
          setDaysC5(item.duration)
          tempStartDateC5 = item.startDate;
          tempEndDateC5 = item.endDate;
        }
      })

      // Usar las variables temporales para la siguiente función
      getTotalApplicationsByType(tempStartDateC1, tempEndDateC1, tempStartDateC2, tempEndDateC2, tempStartDateC3, tempEndDateC3, tempStartDateC4, tempEndDateC4, tempStartDateC5, tempEndDateC5);
    }

    setLoading(false);
  };









  const loadDashBoard = () => {
    setListCyclesPalm([])
    setPalmName("0")
    setLineName("0")
    if (lotId != "0") {
      setTitle("Ciclos de polinización por lotes")
      setSubTitle("Ciclos de polinización por lote agrupado por mes")
      getDataCyclesPalm(startDate, endDate)
    }
    else{
      toast.info("Seleccione un lote", { autoClose: 1000 });
    }
    setKey(Date.now());
  };







  const cardStyle = {
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
    minHeight: "480px"
  };

  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };





  ////APLICACIONES POR TIPO
  const getTotalApplicationsByType = async (start1, end1, start2, end2, start3, end3, start4, end4, start5, end5) => {

    setFirstAppC1("");
    setFirstAppC2("");
    setFirstAppC3("");
    setFirstAppC4("");
    setFirstAppC5("");

    setSecondAppC1("");
    setSecondAppC2("");
    setSecondAppC3("");
    setSecondAppC4("");
    setSecondAppC5("");

    setThirdAppC1("");
    setThirdAppC2("");
    setThirdAppC3("");
    setThirdAppC4("");
    setThirdAppC5("");

    setLoading(true);

    let start = moment(start1).startOf("day").format('YYYY-MM-DD');
    let end = moment(end1).endOf("day").format('YYYY-MM-DD');
    const userId = getValues("userId")
    const resultC1 = await dashboardService.getTotalApplicationsByType(start, end, farmId, lotId, sectionId, selectedLotes, userId);
    if (resultC1) {
      if (resultC1.length > 0) {
        setFirstAppC1(resultC1[0].totalFirst);
        setSecondAppC1(resultC1[0].totalSecond);
        setThirdAppC1(resultC1[0].totalThird);
      }
    }


    start = moment(start2).startOf("day").format('YYYY-MM-DD');
    end = moment(end2).endOf("day").format('YYYY-MM-DD');
    const resultC2 = await dashboardService.getTotalApplicationsByType(start, end, farmId, lotId, sectionId, selectedLotes, userId);
    if (resultC2) {
      if (resultC2.length > 0) {
        setFirstAppC2(resultC2[0].totalFirst);
        setSecondAppC2(resultC2[0].totalSecond);
        setThirdAppC2(resultC2[0].totalThird);
      }
    }


    start = moment(start3).startOf("day").format('YYYY-MM-DD');
    end = moment(end3).endOf("day").format('YYYY-MM-DD');
    const resultC3 = await dashboardService.getTotalApplicationsByType(start, end, farmId, lotId, sectionId, selectedLotes, userId);
    if (resultC3) {
      if (resultC3.length > 0) {
        setFirstAppC3(resultC3[0].totalFirst);
        setSecondAppC3(resultC3[0].totalSecond);
        setThirdAppC3(resultC3[0].totalThird);
      }
    }

    start = moment(start4).startOf("day").format('YYYY-MM-DD');
    end = moment(end4).endOf("day").format('YYYY-MM-DD');
    const resultC4 = await dashboardService.getTotalApplicationsByType(start, end, farmId, lotId, sectionId, selectedLotes, userId);
    if (resultC4) {
      if (resultC4.length > 0) {
        setFirstAppC4(resultC4[0].totalFirst);
        setSecondAppC4(resultC4[0].totalSecond);
        setThirdAppC4(resultC4[0].totalThird);
      }
    }

    start = moment(start5).startOf("day").format('YYYY-MM-DD');
    end = moment(end5).endOf("day").format('YYYY-MM-DD');
    const resultC5 = await dashboardService.getTotalApplicationsByType(start, end, farmId, lotId, sectionId, selectedLotes, userId);
    if (resultC5) {
      if (resultC5.length > 0) {
        setFirstAppC5(resultC5[0].totalFirst);
        setSecondAppC5(resultC5[0].totalSecond);
        setThirdAppC5(resultC5[0].totalThird);
      }
    }





    setLoading(false);



  };



  useEffect(() => {
    getLisFarm();
    setValue("days", 165)
    setValue("weight", 40)
    loadDashBoard();
  }, []);



  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <ToastContainer />
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Seguimiento de ciclos de polinización por lote</Divider>
      </div>
      <div className="row">
        <div className="col-12">
          <form
            className="form-react"
            defaultValue={{ weight: 40 }}

          >
            <div className="row mb-3">


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>




              <div className="col-12 col-sm-2 d-none">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-secondary"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              <div className=" col-12  col-sm-2 d-none">
                <label className="text-secondary fw-bold">Hasta</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control 
                text-secondary"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>







              <div className="col-12 col-sm-6 d-none">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>



              <div className=" col-3">
                <label className="text-secondary fw-bold">Lote</label>
                <select
                  className="form-control text-secondary"
                  {...register("lot")}
                  onChange={(e) => {
                    const value = e.target.value;
                    setLotId(value);
                  }}
                >
                  {listLots.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className=" col-3">
                <label>Palma de referencia</label>
                <select className="form-control" {...register("palm")}>
                  {referencePalmList.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}  >
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => loadDashBoard()}
                  >
                    <i className="bi bi-search fa-lg m-2" /> Buscar
                  </button>
                </Spin>
              </div>








            </div>





          </form>
        </div>









        <div className={startDateC1 == "" ? "d-none" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle} >

            <strong>Seguimiento de los últimos {limit - 1} ciclos del lote</strong><br></br>
            <strong>Palma de referencia:</strong> Línea: {lineName} Palma: {palmName}
            <table className="table table-responsive table-bordered ">
              <thead className="table-primary" >
                <tr>
                  <th>Inicio</th>
                  <th>Fin</th>
                  <th>Duracion</th>
                  <th>Primera</th>
                  <th>Segunda</th>
                  <th>Tercera</th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td>{startDateC1}</td>
                  <td>{endDateC1}</td>
                  <td>{daysC1}</td>
                  <td>{firstAppC1}</td>
                  <td>{secondAppC1}</td>
                  <td>{thirdAppC1}</td>
                </tr>

                <tr>
                  <td>{startDateC2}</td>
                  <td>{endDateC2}</td>
                  <td>{daysC2}</td>
                  <td>{firstAppC2}</td>
                  <td>{secondAppC2}</td>
                  <td>{thirdAppC2}</td>
                </tr>

                <tr>
                  <td>{startDateC3}</td>
                  <td>{endDateC3}</td>
                  <td>{daysC3}</td>
                  <td>{firstAppC3}</td>
                  <td>{secondAppC3}</td>
                  <td>{thirdAppC3}</td>
                </tr>

                <tr>
                  <td>{startDateC4}</td>
                  <td>{endDateC4}</td>
                  <td>{daysC4}</td>
                  <td>{firstAppC4}</td>
                  <td>{secondAppC4}</td>
                  <td>{thirdAppC4}</td>
                </tr>


                <tr>
                  <td>{startDateC5}</td>
                  <td>{endDateC5}</td>
                  <td>{daysC5}</td>
                  <td>{firstAppC5}</td>
                  <td>{secondAppC5}</td>
                  <td>{thirdAppC5}</td>
                </tr>



              </tbody>
            </table>
          </div>
        </div>








      </div>
    </div>
  );
};

export default ComparativeCycles;
